import React from 'react';
import { bool, node, object } from 'prop-types';
import styled from 'styled-components';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const TypeAheadContainerStyled = styled.div`
    background-color: ${MIGRATED_COLORS.white};
    border: 1px solid ${MIGRATED_COLORS.light};
    font-family: Roboto;
    font-size: 0.875rem;
    max-height: 24rem;
    overflow-x: hidden;
    overflow-y: scroll;
    position: relative;
    width: 100%;
    z-index: 100;
    & ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
`;

const IsLoadingContainerStyled = styled.div`
    background-color: ${MIGRATED_COLORS.white};
    border: 1px solid ${MIGRATED_COLORS.light};
    color: ${MIGRATED_COLORS.light};
    font-family: Roboto;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    position: relative;
    width: 100%;
    z-index: 10;
`;

const TypeAheadContainer = ({ children, containerProps, isLoading, showTypeAheadContainer }) => {
    const { key, ...restContainerProps } = containerProps || {};
    return (
        (isLoading && showTypeAheadContainer && (
            <IsLoadingContainerStyled key={key} {...restContainerProps}>
                Loading...
            </IsLoadingContainerStyled>
        )) ||
        (children && showTypeAheadContainer && (
            <TypeAheadContainerStyled key={key} {...restContainerProps}>
                {children}
            </TypeAheadContainerStyled>
        )) ||
        null
    );
};

TypeAheadContainer.propTypes = {
    children: node,
    containerProps: object,
    isLoading: bool,
    showTypeAheadContainer: bool,
};

TypeAheadContainer.defaultProps = {
    children: null,
    containerProps: {},
    isLoading: false,
    showTypeAheadContainer: true,
};

export default TypeAheadContainer;
